export default {"src":"/_next/static/media/icon-bank-transfer.204d9b0b.svg","height":20,"width":113,"blurWidth":0,"blurHeight":0};